import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Map = ({ onLoad, ...props }) => {
  useEffect(() => {
    if (onLoad) onLoad();
  }, [onLoad]);

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1066"
    >
      <polygon
        data-floor="0"
        points="102 640 112.45 640 144 638 172.97 638 203.77 638 227.82 638 290.23 639 290.23 634.57 323.6 634.57 335.38 634.57 335.38 630.37 375 629 420 628 452.07 628 513.03 628 594 624 670 621 687.54 621 687.54 614.43 746.02 614.43 815 611 847.87 611 993 608 1076 605 1161 602 1229 600 1421 614 1421 634.42 1595 632 1693 630 1693 703.87 1494.27 703.87 1494 727 1232 756 102 733.72 102 640"
      />
      <polygon
        data-floor="1"
        points="102 640 144 638 227.82 638 290.23 639 290.23 634.57 335.38 634.57 335.38 630.37 420 628 513.03 628 637.43 622.29 687.54 621 687.54 614.43 747.9 614.43 815 611 993 608 1229 600 1421 614 1421 634.42 1507.56 633.22 1586.57 632.12 1693 630 1693 584.94 1693 569.66 1693 559.65 1685.61 533 1659.27 533 1611 524 1489 528 1458 438 1451 453 1419 457 1291 420 1279 400 1014 426 942 333 814 296 702 474 580 488 523 405 412 386 341 529 305 524 268 453 162 443 102 587.93 102 640"
      />
      <path
        data-floor="2"
        d="M260.14,452.26,268,453l37,71,36,5,61.66-124.19L287,429ZM523,405l57,83,122-14,96.83-153.89L454.09,393.2Zm929-4-66-205L857.55,308.59,942,333l72,93,265-26,12,20,128,37,32-4,7-15,31,90,122-4,48.27,9h26.34L1654,376Zm359,83-133.54,8.52,8.15,40.48h4.9L1767,610l27-20h33Z"
        transform="translate(0 0)"
      />
    </svg>
  );
};

Map.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

export default Map;
